import { useQuery } from '@tanstack/react-query';

import { fetchCountEntitiesByTag } from '@/api/v4/tags.api';
import { QueryKey } from '@/config/query-client';

export const useCountEntitiesByTag = (tagId: string) => {
  return useQuery({
    queryKey: [QueryKey.CountEntitiesByTag, tagId],
    queryFn: fetchCountEntitiesByTag.bind(null, tagId),
    staleTime: 1000 * 10,
  });
};
